import * as React from 'react'
import { FC, useMemo } from 'react'
import { BillToMatchCardProps } from './typings'
import { Header, Footer } from './atoms'
import { ServiceLocationList } from './ServiceLocationList'
import { SmallLocationCard } from '@user/components/Location'
import { locationToLocationDTO } from '@user/store/entityLocations'
import { useToggleBoolean } from '@user/utils/useToggleBoolean'

export const BillToMatchCard: FC<BillToMatchCardProps> = (props) => {
  const { styles, billTo, selectedBillTo } = props

  const checked = selectedBillTo?.id === billTo.id

  const [open, toggleOpen] = useToggleBoolean()

  const location = useMemo(() => locationToLocationDTO(billTo), [billTo])

  const style = useMemo(
    () =>
      ({
        '--backgroundColor': checked ? '#F4F8FA' : '',
      } as React.CSSProperties),
    [checked],
  )

  return (
    <SmallLocationCard
      {...props}
      className={styles.billToCard}
      location={location}
      isEditable={false}
      open={open}
      toggleOpen={toggleOpen}
      style={style}
      header={<Header {...props} checked={checked} />}
      footer={
        <Footer>
          <ServiceLocationList {...props} />
        </Footer>
      }
    />
  )
}
BillToMatchCard.displayName = 'BillToMatchCard'
